import React from "react";
import { Grid, Typography, Button } from "@mui/material";
import EngageLogo from "../../../assets/engage-full-color.svg";
import "./PrivacyPolicy.scss";

const PrivacyPolicy = (props) => {
  return (
    <Grid className={"vestevo-policies"} container spacing={3}>
      <Grid item xs={8}>
        <Typography component={"h1"} variant={"h1"}>
          Privacy and Security Policy
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Button
          variant={"contained"}
          color={"secondary"}
          onClick={props.onClose}
        >
          Close
        </Button>
      </Grid>
      <Grid item xs={12}>
        <div className={"company-logos"}>
          <img
            src={EngageLogo}
            alt={"Engage"}
            title={"Engage"}
            width={"203px"}
          />
        </div>
      </Grid>
      <Grid item xs={12}>
        <p>
          Information security is a fundamental policy within WealthCentral Inc.
          All employees of WealthCentral are aware of the procedures that must
          be taken to safeguard personal non-public information. Protecting the
          confidentiality of personal, non-public information is more than a
          procedure.
        </p>
        <p>
          We give certain employees and/or independent contractors access to
          personal information we may acquire during the course of providing
          services. Those contractors assist us with providing you the services
          requested from Engage. All those contractors are required to sign
          contracts in which they promise to protect any private, non-public
          information using procedures reasonably equivalent to ours. We also
          may disclose personal information to attorneys, collection agencies,
          or law enforcement authorities to address potential user violations,
          other contract violations, or illegal behavior. And we disclose any
          information demanded in a court order or otherwise required by law or
          to prevent imminent harm to persons or property.
        </p>
        <p>
          WealthCentral’s top priority is to protect the confidentiality and
          integrity of the information of our customers and their clients.
          WealthCentral, and Engage, require a username and password combination
          to access the site's content and features. We use all reasonable
          efforts to comply with guidelines concerning protection of private
          information. Appropriate safeguards have been implemented each step of
          the way. The safeguards include:
        </p>
        <ol>
          <li>
            Encryption – all applications and other communications requesting
            confidential information must be set up in a "secure environment" on
            our site, transmitted to us securely through the use of encryption
            and maintained in a secure format upon receipt by us until
            distribution to the appropriate business area.
          </li>
          <li>
            Firewalls – WealthCentral and Engage has in place an Internet
            firewall designed to securely separate the Internet from Engage’s
            internal computer systems and databases. Data coming from customer
            computers via the Internet flows through a series of safety
            checkpoints on its way to our internal systems so that only
            authorized messages and transactions enter our computer systems.
          </li>
          <li>
            Monitoring – WealthCentral and Engage monitor all internal systems
            to ensure that there has been no security attack or attempted
            break-in. We also arrange for regular independent security checks on
            our computer systems to ensure our high standards are being complied
            with.
          </li>
        </ol>
        <p>
          We may change this Privacy/Security Policy at any time by posting a
          new version on our website at engage.wealthcentral.com.
        </p>
        <p>
          &copy; Engage, LLC 2021-2023, All rights reserved. Engage. A division
          of WealthCentral
        </p>
      </Grid>
    </Grid>
  );
};

export default PrivacyPolicy;
